import { render, staticRenderFns } from "./TheVisaList.vue?vue&type=template&id=65e63cea&"
import script from "./TheVisaList.vue?vue&type=script&lang=js&"
export * from "./TheVisaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports